import React, { useState } from "react";
import './staff-modules.css';

const SAMPLE_BATCHES = ["GNM 1st Year", "GNM 2nd Year", "GNM 3rd Year"];
const SAMPLE_DEPARTMENTS = ["General Ward", "Pediatrics", "ICU", "Community Health"];
const SAMPLE_STUDENTS = [
  { id: 1, name: "Anjali Sharma" },
  { id: 2, name: "Rahul Gupta" },
  { id: 3, name: "Sneha Reddy" }
];

export default function Clinical() {
  const [batch, setBatch] = useState(SAMPLE_BATCHES[0]);
  const [department, setDepartment] = useState(SAMPLE_DEPARTMENTS[0]);
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [postingList, setPostingList] = useState(
    SAMPLE_STUDENTS.map((s) => ({ ...s, attendance: "Present", feedback: "" }))
  );
  const [showFeedback, setShowFeedback] = useState(false);
  const [message, setMessage] = useState("");

  const handleAttendanceChange = (id, value) => {
    setPostingList((prev) =>
      prev.map((s) => (s.id === id ? { ...s, attendance: value } : s))
    );
  };

  const handleFeedbackChange = (id, value) => {
    setPostingList((prev) =>
      prev.map((s) => (s.id === id ? { ...s, feedback: value } : s))
    );
  };

  const handleMarkAll = (status) => {
    setPostingList((prev) => prev.map((s) => ({ ...s, attendance: status })));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage("Clinical posting record saved successfully!");
    setShowFeedback(true);
  };

  return (
    <div className="module-wrapper">
      <h2>Clinical Posting</h2>
      <p>
        Schedule, assign, and monitor clinical postings for students. Set up clinical rotation plans, track attendance in clinical areas, and manage supervisor feedback.
      </p>
      <form className="clinical-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <label>Date:</label>
          <input type="date" value={date} onChange={e => setDate(e.target.value)} required />
          <label>Batch:</label>
          <select value={batch} onChange={e => setBatch(e.target.value)}>
            {SAMPLE_BATCHES.map((b) => (
              <option key={b}>{b}</option>
            ))}
          </select>
          <label>Department:</label>
          <select value={department} onChange={e => setDepartment(e.target.value)}>
            {SAMPLE_DEPARTMENTS.map((d) => (
              <option key={d}>{d}</option>
            ))}
          </select>
        </div>
        <div className="clinical-actions">
          <button type="button" onClick={() => handleMarkAll("Present")}>Mark All Present</button>
          <button type="button" onClick={() => handleMarkAll("Absent")}>Mark All Absent</button>
        </div>
        <table className="clinical-table">
          <thead>
            <tr>
              <th>Student Name</th>
              <th>Attendance</th>
              <th>Supervisor Feedback</th>
            </tr>
          </thead>
          <tbody>
            {postingList.map((student) => (
              <tr key={student.id}>
                <td>{student.name}</td>
                <td>
                  <select
                    value={student.attendance}
                    onChange={(e) => handleAttendanceChange(student.id, e.target.value)}
                  >
                    <option>Present</option>
                    <option>Absent</option>
                    <option>Leave</option>
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    value={student.feedback}
                    onChange={(e) => handleFeedbackChange(student.id, e.target.value)}
                    placeholder="Enter feedback"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className="primary-action" type="submit">Save Posting Record</button>
      </form>
      {message && <div className="form-success">{message}</div>}
      {showFeedback && (
        <div className="clinical-report">
          <h3>Clinical Posting Report: {batch} - {department} ({date})</h3>
          <table className="clinical-report-table">
            <thead>
              <tr>
                <th>Student</th>
                <th>Attendance</th>
                <th>Supervisor Feedback</th>
              </tr>
            </thead>
            <tbody>
              {postingList.map((s) => (
                <tr key={s.id}>
                  <td>{s.name}</td>
                  <td>{s.attendance}</td>
                  <td>{s.feedback || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button
            className="secondary-action"
            style={{ marginTop: 12 }}
            onClick={() => window.print()}
          >
            Download/Print Report
          </button>
        </div>
      )}
    </div>
  );
}